<ngb-alert [type]="type()" [dismissible]="dismissible()">
  {{ message() }}
</ngb-alert>
